import { FC } from 'react';
import { Divider, DividerProps } from '@chakra-ui/react';

type ShortenedDividerProps = Omit<DividerProps, 'width'>;

/**
 * A shortened divider mostly used during onboarding between a heading and a subsequent content.
 */
const ShortenedDivider: FC<ShortenedDividerProps> = ({ ...props }) => (
  <Divider width="space-48" {...props} />
);

export default ShortenedDivider;
